import svgUrl from "ni:svgr;E3PH3FDTj8sNAeay8UAyfGc5x3batVGjIMgZDUPqjxM";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiXlsFileSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9 2H3v12h9V5h-2a1 1 0 0 1-1-1V2Zm4 3L9 1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V5Zm-3 4V7H8v2h2ZM5 7h2v2H5V7Zm0 5v-2h2v2H5Zm5-2v2H8v-2h2ZM5 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiXlsFileSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiXlsFileSIcon)";
}